import { useEffect, useRef } from "react";

import { useAuth } from "src/lib/auth";
import { trackSignUp } from "src/lib/googleAnalytics";

/**
 * Emits user-lifecycle events that can only be known after authentication.
 */
const GoogleAnalyticsUserEvents = () => {
  const { currentUser } = useAuth();
  const trackedSignUpUserIdRef = useRef(null);

  useEffect(() => {
    if (
      !currentUser?.isNewUser ||
      !currentUser?.id ||
      trackedSignUpUserIdRef.current === currentUser.id
    ) {
      return;
    }

    if (trackSignUp(currentUser.signUpMethod || "unknown")) {
      trackedSignUpUserIdRef.current = currentUser.id;
    }
  }, [currentUser?.id, currentUser?.isNewUser, currentUser?.signUpMethod]);

  return null;
};

export default GoogleAnalyticsUserEvents;
